import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-xiaoshou",
  "use": "icon-icon-xiaoshou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-xiaoshou\"><defs><style type=\"text/css\"></style></defs><path d=\"M514.279424 323.584a156.125867 156.125867 0 0 1 155.8528-156.0576A156.125867 156.125867 0 0 1 826.053291 323.584a156.125867 156.125867 0 0 1-155.921067 155.989333A156.125867 156.125867 0 0 1 514.279424 323.584m503.466667-228.9664c0-49.015467-39.799467-88.8832-87.176534-88.8832h-0.068266C928.999424 5.666133 775.058091 0 658.799957 0c-133.802667 0-145.885867 6.485333-160.3584 20.957867L291.525291 228.010667 25.967957 493.7728a89.429333 89.429333 0 0 0 0.273067 126.293333l377.582933 377.787734c16.930133 16.861867 39.3216 26.146133 63.2832 26.146133 23.893333 0 46.148267-9.216 62.805334-25.941333l295.5264-295.594667 177.015466-177.220267c15.633067-15.5648 30.3104-30.3104 15.291734-430.626133\" fill=\"#ffffff\" p-id=\"8282\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-xiaoshou.svg
// module id = 4MLM
// module chunks = 29